const currencyFormatter = new Intl.NumberFormat('en-US', {
    // style: 'currency',
    // currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export const TaxWagesReportHeader = [
    { field: 'id', headerName: '#', width: 0, headerClassName: 'super-app-theme--header', groupable: false, aggregable: true},
    { field: 'emri', headerName: 'Emri', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'mbiemri', headerName: 'Mbeimri', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'numripersonal', headerName: 'Numri Individual i punëtorit', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    // {
    //     field: 'total', headerName: 'Total', type: 'string', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
    //     valueFormatter: (value) => {
    //         if (!value) {
    //             return value;
    //         }
    //         return currencyFormatter.format(value);
    //     },
    // },
    {
        field: 'pagabruto', headerName: 'Bruto paga për muaj', type: 'string', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'kontributipunetorit', headerName: 'Kontributi pensional i të punësuarit', type: 'string', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'kontributipunedhenesit', headerName: 'Kontributi pensional i punëdhënësit', type: 'string', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'kontributisuplementarpunesuarit', headerName: 'Kontributi suplementar i të punësuarit', type: 'string', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'kontributisuplementarpunedhenesit', headerName: 'Kontributi suplementar i punëdhënësit', type: 'string', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },

    { field: 'puneprimare', headerName: 'Punë Primare', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'perfshihenkontributet', headerName: 'Përfshihen Kontributet', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'aplikohettatiminepaga', headerName: 'Aplikohet Tatimi ne Paga', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
]

